"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("./Flex.js"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _String = _interopRequireDefault(require("./String.js"));

var _lab = require("@material-ui/lab");

var _core = require("@material-ui/core");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Abstraction of Material UI Lab's `Alert`
 */
class Banner extends _react.default.PureComponent {
  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_lab.Alert, {
      action: this.props.action,
      classes: this.props.classes,
      closeText: this.props.closeLabel,
      onClose: this.props.onClose,
      severity: this.props.type,
      variant: this.props.variant,
      ...this.props.AlertProps,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
        gap: this.props.gap,
        ...this.props.FlexProps,
        children: [this.props.title && /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
          bold: true,
          str: this.props.title,
          ...this.props.TitleStringProps
        }), this.props.str && /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
          gap: this.props.gap,
          str: this.props.str,
          ...this.props.StringProps
        }), this.props.children]
      })
    });
  }
  /**
   * Styles.
   *
   * @return {Object}
   */


  static styles() {
    return {
      action: {
        alignSelf: "flex-start",
        paddingTop: "0.8rem"
      },
      icon: {
        flexShrink: 0
      }
    };
  }

  static propTypes = {
    AlertProps: _propTypes.default.object,
    FlexProps: _propTypes.default.object,
    StringProps: _propTypes.default.object,
    TitleStringProps: _propTypes.default.object,
    action: _propTypes.default.node,
    children: _propTypes.default.node,
    closeLabel: _propTypes.default.string,
    gap: _propTypes.default.number,
    onClose: _propTypes.default.func,
    str: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.array]),
    title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    type: _propTypes.default.oneOf(["info", "success", "warning", "error"]),
    variant: _propTypes.default.oneOf(["standard", "filled", "outlined"])
  };
  static defaultProps = {
    closeLabel: "Close",
    gap: 0.5,
    type: "info",
    variant: "standard"
  };
}

var _default = (0, _core.withStyles)(Banner.styles)(Banner);

exports.default = _default;